module.exports = __webpack_public_path__ + "img/bg_pop_top_small.fa6558d7.png";